export default {
  email: {
    name: 'email',
    type: 'email',
    label: 'Email Address',
    required: true,
    'data-at-footer-emailsignupform-email': true
  }
}
